import apiClient from './api';

const paymentService = {
    getBalance: () => apiClient.get('/payment/wallet/balance').then(res => res.data),
    createDeposit: (amount) => apiClient.post('/payment/deposit', { amount }).then(res => res.data),
    checkSepayTransaction: (code, amount) => apiClient.post('/payment/sepay/check', { code, amount }).then(res => res.data),
    cancelDeposit: (code) => apiClient.post('/payment/deposit/cancel', { code }).then(res => res.data),
    getTransactions: (params) => apiClient.get('/payment/transactions', { params }).then(res => res.data),
};

export default paymentService;
